// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-card-body[data-v-142f9060] {\n  min-height: 15em;\n}\n.button.is-static[data-v-142f9060] {\n  min-width: 4.5rem;\n}\n.input.no-radius[data-v-142f9060] {\n  border-radius: 0;\n}", ""]);
// Exports
module.exports = exports;
